export default __webpack_public_path__ + "static/media/delete.4d41c23e.svg";